import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 221发射气泡
 */
import DataUtils from '../DataUtils'

export default class EventSendAirBubble extends EventBase {
  index: number
  constructor() {
    super()
    this.index = 0
    this.Parameter = [
      '1',
      '0',
      '',
      '1',
      '',
      '',
      '',
      '0',
      '0',
      this.index + '',
      '',
      '0',
      '',
      '0',
      '0',
      '0',
      '0',
    ]
  }

  /**
   * 编号3-22
   */
  get ID() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set ID(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 位置（1：左2：中3：右）
   */
  get Position() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set Position(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /**
   * 边框图片
   */
  get BorderPath() {
    return this.Parameter?.[2] ?? ''
  }
  set BorderPath(value) {
    this.Parameter && (this.Parameter[2] = value.toString())
  }

  /**
   * 类型（1：文字，2：图片3：语音）
   */
  get MessageType() {
    return parseInt(this.Parameter?.[3] ?? '')
  }
  set MessageType(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
    if (value.toString() == "1"){
      this.localesParams = [4, 6, 7, 13, 14]
    } else {
      this.localesParams = [4, 7, 13, 14]
    }
  }

  /**
   * 姓名
   */
  get Name() {
    return this.Parameter?.[4] ?? ''
  }
  set Name(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }

  /**
   * 头像
   */
  get FacePath() {
    return this.Parameter?.[5] ?? ''
  }
  set FacePath(value) {
    this.Parameter && (this.Parameter[5] = value.toString())
  } 

  /**
   * 内容（文字：文字内容/图片：文件名/语音：文件名）
   */
  get MessageConten() {
    return this.Parameter?.[6] ?? ''
  }
  set MessageConten(value) {
    this.Parameter && (this.Parameter[6] = value.toString())
  }

  /**
   * 文件大小
   */
  get FileSize() :string{
    return this.Parameter?.[7] ?? ''
  }
  set FileSize(value) {
    this.Parameter && (this.Parameter[7] = value.toString())
  }

  get Description() {
    return this.Parameter?.[8] ?? ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[8] = value.toString())
  }

  /**
   * 发射气泡事件在整个工程中的唯一标识号
   */
  get Index() {
    return parseInt(this.Parameter?.[9] ?? '')
  }
  set Index(value) {
    this.Parameter && (this.Parameter[9] = value.toString())
  }

  /**
   * 小喇叭图片
   */
  get Trumpet() {
    return this.Parameter?.[10] ?? ''
  }
  set Trumpet(value) {
    this.Parameter && (this.Parameter[10] = value.toString())
  }

  /**
   * 角色ID
   */
  get RoleID() {
    return parseInt(this.Parameter?.[11] ?? '')
  }
  set RoleID(value) {
    this.Parameter && (this.Parameter[11] = value.toString())
  }
  /**
   * 发射图片的小缩略图 reskey
   */
  get MinPicture() {
    return this.Parameter?.[12] ?? ''
  }
  set MinPicture(value) {
    this.Parameter && (this.Parameter[12] = value.toString())
  }

  /**
   * （发射图片）小缩略图宽度 reskey
   */
  get MinPictureW() : string{
    return this.Parameter?.[13] ?? ''
  }
  set MinPictureW(value) {
    this.Parameter && (this.Parameter[13] = value.toString())
  }

  /**
   * （发射图片）小缩略图高度 reskey
   */
  get MinPictureH() {
    return this.Parameter?.[14] ?? ''
  }
  set MinPictureH(value) {
    this.Parameter && (this.Parameter[14] = value.toString())
  }


  /// <summary>
  ///15,16拓展
  /// </summary>
  Code = EventID.SendAirBubble
  public GetParameter() {
    return this.Parameter
  }
}
